










let index={
  tuofuTab(){
    $(".tuofu_item").click(function(){
      $(this).siblings().removeClass("cur")
      $(this).addClass("cur")
      $(this).closest(".box3_wrapper").find(".tuofu_imgBox img").hide()
      // $(".tuofu_imgBox img").hide()
      $(this).closest(".box3_wrapper").find(".tuofu_imgBox img").eq($(this).index()).show()
    })
  },
  swiperInit(){
    let gxhswiper2=null
    let gxhswiper=new Swiper('.gxh_container', {
      pagination: {
        el: '.swiper-pagination',
      },
      // on:{
      //   transitionStart: function(){
      //     console.log(this.activeIndex)
      //     $(".gxh_item").removeClass("active")
      //     $(".gxh_item").eq(this.activeIndex).addClass("active")
      //   }
      // },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    })
    
    $(".gxh_item").click(function(){
      $(".gxh_item").removeClass("active")
      $(this).addClass("active")
      $(".gxh_box .swiper-container").removeClass("show").eq($(this).index()).addClass("show")
      if(!gxhswiper2){
        gxhswiper2=new Swiper('.gxh_container2', {
          pagination: {
            el: '.swiper-pagination',
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          }
        })
      }
      // gxhswiper.slideTo($(this).index())
    })
    new Swiper('.city_container', {
      autoplay: true,//可选选项，自动滑动
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
      }
    })
  },
  teacherTab(){
    var oTabB = document.getElementsByClassName("reason_tab");
    var oContentB = document.getElementsByClassName("reason_content");
  
    function addClass(elem, value) {
      if (!elem.className) {
        elem.className = value;
      } else {
        var newClassName = elem.className;
        newClassName += " ";
        newClassName += value;
        elem.className = newClassName;
      }
    }
  
    function deleteClass(elem, value) {
      var newClassName = elem.className;
  
      if (newClassName.indexOf(value)) {
        elem.className = newClassName.replace(value, " ");
      }
    }
  
    for (var i = 0, len = oTabB.length; i < len; i++) {
      oTabB[i].index = i;
  
      oTabB[i].onmouseover = function () {
        var This = this;
  
        for (var j = 0; j < len; j++) {
          deleteClass(oTabB[j], "activeTabNew");
          deleteClass(oContentB[j], "activeNew");
        }
  
        addClass(This, "activeTabNew");
        addClass(oContentB[This.index], "activeNew");
      };
    }
  },
  booksTab(){
    $(".tab-box .tab").hover(function () {
      $(this).addClass("red-bgc").siblings().removeClass("red-bgc");
      $(".books .pic-content").eq($(this).index()).show().siblings().hide();
    });
  },
  select(){
    $(".submit_select .submit_input").click(function(e){
      e.stopPropagation()
      $(this).next().toggleClass("show")
    })
    $("body").click(function(){
      $(".submit_select_box").removeClass("show")
    })
    $(".select_course .submit_select_item").click(function(){
      let _this=$(this)
      _this.parent().prev().text(_this.text())
      $(".course_input").val(_this.text())
    })
    $(".select_city .submit_select_item").click(function(){
      let _this=$(this)
      _this.parent().prev().text(_this.text())
      $(".city_input").val(_this.text())
    })
    $(".submit_close").click(function(){
      $(".submit_box").hide()
    })
  },
  other(){
    $(".goSchool").click(function(){
      $(".leyu_yspd,.toumingbi_yspd").show()
    //   $("html,body").animate({
    //     scrollTop:$(".school_map").offset().top
    // }, 500);
    })
    $(".close_ly").click(function(){
      $(".leyu_yspd,.toumingbi_yspd").hide()
    })
  },
  dialogSubmit(){
    $(".dialog_submit_select .dialog_input").click(function(e){
      e.stopPropagation()
      let _this=$(this)
      $(".dialog_submit_selectBox").hide()
      _this.next().show()
    })
    $("body").click(function(){
      $(".dialog_submit_selectBox").hide()
    })
    $(".dialog_city .dialog_submit_selectItem").click(function(){
      let _this=$(this)
      $(".dialog_city").val(_this.text())
      $(".dialog_city .dialog_input").text(_this.text())
    })
    $(".dialog_course .dialog_submit_selectItem").click(function(){
      let _this=$(this)
      $(".dialog_course").val(_this.text())
      $(".dialog_course .dialog_input").text(_this.text())
    })
    $(".dialog_close").click(function(){
      $(".dialog_submit").hide()
    })
    $(".dialog_show").click(function(){
      $(".dialog_1").show()
    })
    // $(".dialog_submit_1").click(function(e){
    //   if(!$(".dialog_country").val()){
    //     index.msgTips("拟申请国家/地区不能为空")
    //     e.stopPropagation()
    //     e.preventDefault()
    //     return false
    //   }else{
    //     var val=$(".dialog_course").val()
    //     val+=$(".dialog_country").val()
    //     $(".dialog_course").val(val)
    //     // $('.dialog_1').listenForm({
    //     //   contentName: [{
    //     //     search: "?jtppzq",
    //     //     name: "2020-4R个性化课程（百品）"
    //     //   }, {
    //     //     search: "?360jtppzq",
    //     //     name: "2020-4R个性化课程（3品）"
    //     //   }, {
    //     //     search: "",
    //     //     name: "2020-4R个性化课程-报名（pc）"
    //     //   }],
    //     //   submitTarget: '.dialog_submit_1',
    //     //   courseRequired: true,
    //     //   cityRequired: true
    //     // });
    //   }
      
    // })
    $('.dialog_1').listenFormS({
          contentName: [{
            search: "?jtppzq",
            name: "4R个性化课程（百品）"
          }, {
            search: "?360jtppzq",
            name: "4R个性化课程（360）"
          }, {
            search: "",
            name: "4R个性化课程（pc）"
          }],
          submitTarget: '.dialog_submit_1',
          courseRequired: true,
          cityRequired: true,
          emailRequired:true
        });
  },
  msgTips(t, i, s) {
    var e = (s = s || 2e3) + 500
      , n = "";
      n = "success" === i ? '<div id="msgTips" class="success">' + t + "</div>" : '<div id="msgTips">' + t + "</div>",
      $("body").append(n),
      setTimeout(function() {
          $("#msgTips").addClass("fade-in")
      }, 0),
      setTimeout(function() {
          $("#msgTips").removeClass("fade-in")
      }, s),
      setTimeout(function() {
          $("#msgTips").remove()
      }, e)
  },
  init(){
    this.tuofuTab()
    this.swiperInit()
    this.teacherTab()
    this.booksTab()
    this.select()
    this.other()
    this.dialogSubmit()
  }
}

index.init()

